import { useState } from "react";

import { IgCodeEditor, IgLink } from "@intelligems/ig-theme";
import { Collapse } from "@mui/material";
import Stack from "@mui/material/Stack";

// The raw upsell template — authored by the AI / starter default and rarely
// hand-edited, so it lives behind an "advanced" toggle at the bottom of the panel.
export const TemplateSection = ({
  template,
  onChange,
}: {
  template: string;
  onChange: (changes: { template?: string }) => void;
}) => {
  const [showTemplate, setShowTemplate] = useState(false);

  return (
    <Stack spacing={3}>
      <IgLink
        onClick={() => setShowTemplate((s) => !s)}
        sx={{ alignSelf: "flex-start", cursor: "pointer" }}
      >
        {showTemplate ? "Hide template" : "Edit template (advanced)"}
      </IgLink>
      <Collapse in={showTemplate} unmountOnExit>
        <IgCodeEditor
          language="html"
          height="320px"
          value={template}
          onChange={(v) => onChange({ template: v ?? "" })}
        />
      </Collapse>
    </Stack>
  );
};
